// This polyfills :scope for IE/Edge/older browsers
import 'element-qsa-scope';

import {ie} from './feature.js';

// console.log('Site:polyfill');
// console.log('ie()', ie());

// Polyfills for features which polyfill.io doesn't cover
if (ie()) {
  // Polyfill from https://gist.github.com/brettz9/4212217

  // Adds support for selectedOptions
  /**
   * @requires polyfill: Array.from {@link https://gist.github.com/4212262}
   * @requires polyfill: Array.prototype.filter {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter}
   * @requires polyfill: Object.defineProperty {@link https://github.com/eligrey/Xccessors}
   * @license MIT, GPL, do whatever you want
   */
  (function () {
    // Inspired by http://stackoverflow.com/a/7754729/271577
    function PseudoHTMLCollection(arr) {
      let i, arrl;

      for (i = 0, arrl = arr.length; i < arrl; i++) {
        this[i] = arr[i];
      }

      try {
        Object.defineProperty(this, 'length', {
          get() {
            return arr.length;
          },
        });
      } catch (e) { // IE does not support accessors on non-DOM objects, so we can't handle dynamic (array-like index) addition to the collection
        this.length = arr.length;
      }

      if (Object.freeze) { // Not present in IE, so don't rely on security aspects
        Object.freeze(this);
      }
    }

    PseudoHTMLCollection.prototype = {
      constructor : PseudoHTMLCollection,
      item(i) {
        return typeof this[i] !== 'undefined' && this[i] !== null ? this[i] : null;
      },
      namedItem(name) {
        let i, thisl;

        for (i = 0, thisl = this.length; i < thisl; i++) {
          if (this[i].id === name || this[i].name === name) {
            return this[i];
          }
        }

        return null;
      },
    };

    Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', {
      get() {
        return new PseudoHTMLCollection(Array.from(this.options).filter(function (option) {
          return option.selected;
        }));
      },
    });
  }());
}
